import styled from 'styled-components';
import { Card } from '@movember/mo-gel';

export const StyledOutcomesContainer = styled(Card)`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
  padding: 39px 16px;

  @media screen and (min-width: ${(props) => props.theme.breakpoints && props.theme.breakpoints.sm}) {
    padding: 36px 27px;
  }

  @media screen and (min-width: ${(props) => props.theme.breakpoints.md}) {
    padding: 27px 29px;
  }

  @media screen and (min-width: ${(props) => props.theme.breakpoints.lg}) {
    padding: 37px 36px;
  }
`;

export const StyledHighLevelInsightsContainer = styled.div`
  padding: 0.7rem 0;
  position: relative;
  display: flex;
  flex-direction: column;

  @media screen and (min-width: ${(props) => props.theme.breakpoints && props.theme.breakpoints.lg}) {
    width: 65%;
  }
`;

export const StyledHighLevelInsightWrapper = styled.div`
  padding: 1.4rem 0;
`;

export const StyledButtonWrapper = styled.div`
  width: 100%;
  align-self: flex-end;
  padding-bottom: 0.7rem;

  @media screen and (min-width: ${(props) => props.theme.breakpoints && props.theme.breakpoints.sm}) {
    width: 35%;
  }

  @media screen and (min-width: ${(props) => props.theme.breakpoints && props.theme.breakpoints.md}) {
    width: unset;
  }
`;

export const StyledInsightsButtonContainer = styled.div`
  display: flex;
  flex-direction: column;

  @media screen and (min-width: ${(props) => props.theme.breakpoints && props.theme.breakpoints.lg}) {
    flex-direction: row;
    justify-content: space-between;
  }
`;
